
import '../../../styles/temp.css';

const PublicProfile = () => {
  return (
    
        <div className="public-profile-card-wrapper">
          <div className="public-profile-card">
            <div className="public-profile-initials">MA</div>
            <button className="public-profile-edit-btn">Edit Profile</button>
          </div>
        </div>
  );
};

export default PublicProfile;
